// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__2B63b","optionalLabel":"Label_optionalLabel__2ZucR","required":"Label_required__3q7KN","optional":"Label_optional__KllJv"};